var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NavBar'),_c('div',{staticClass:"max-w-[1600px] mx-auto flex flex-col lg:flex-row lg:gap-8 px-4 sm:px-6 lg:px-10 pt-20 sm:pt-24 pb-12"},[_c('MenuLeft'),_c('main',{staticClass:"w-full lg:flex-1 min-w-0"},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }